import React from 'react';
import { hot } from 'react-hot-loader/root';
import './pages/MainPage/styles.styl';
import { Theme, presetGpnDefault } from '@consta/uikit/Theme';
import App from './App';
import { Provider } from 'react-redux';
import { ReduxRouter } from '@lagunovsky/redux-react-router';
import store from './redux/store';
import { browserHistory } from './history/history';

const AppWrapper = () => {
  return (
    <Provider store={store}>
      <Theme preset={presetGpnDefault}>
        <ReduxRouter history={browserHistory} store={store}>
          <App />
        </ReduxRouter>
      </Theme>
    </Provider>
  );
};

export default hot(AppWrapper);
